var _rect, _g, _g2, _g3, _polyline, _path, _g4, _g5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExampleOverview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1444px",
    height: "320px",
    viewBox: "-5 -20 178 40",
    style: {
      width: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -5,
    y: -20,
    width: 178,
    height: 40,
    fill: "yellow",
    stroke: "blue",
    strokeWidth: 0.2,
    fillOpacity: 0.05,
    strokeOpacity: 0.9
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeOpacity: 0.33,
    strokeWidth: 0.025,
    stroke: "rgb(128,128,128) "
  }, /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -20,
    x2: -5,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4,
    y1: -20,
    x2: -4,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -3,
    y1: -20,
    x2: -3,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -2,
    y1: -20,
    x2: -2,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -1,
    y1: -20,
    x2: -1,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: -20,
    x2: 0,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: -20,
    x2: 1,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -20,
    x2: 2,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 3,
    y1: -20,
    x2: 3,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: -20,
    x2: 4,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: -20,
    x2: 5,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6,
    y1: -20,
    x2: 6,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 7,
    y1: -20,
    x2: 7,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8,
    y1: -20,
    x2: 8,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9,
    y1: -20,
    x2: 9,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10,
    y1: -20,
    x2: 10,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: -20,
    x2: 11,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: -20,
    x2: 12,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: -20,
    x2: 13,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 14,
    y1: -20,
    x2: 14,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15,
    y1: -20,
    x2: 15,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16,
    y1: -20,
    x2: 16,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 17,
    y1: -20,
    x2: 17,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18,
    y1: -20,
    x2: 18,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19,
    y1: -20,
    x2: 19,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: -20,
    x2: 20,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: -20,
    x2: 21,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: -20,
    x2: 22,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: -20,
    x2: 23,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: -20,
    x2: 24,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25,
    y1: -20,
    x2: 25,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 26,
    y1: -20,
    x2: 26,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 27,
    y1: -20,
    x2: 27,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: -20,
    x2: 28,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 29,
    y1: -20,
    x2: 29,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30,
    y1: -20,
    x2: 30,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31,
    y1: -20,
    x2: 31,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32,
    y1: -20,
    x2: 32,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33,
    y1: -20,
    x2: 33,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: -20,
    x2: 34,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: -20,
    x2: 35,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36,
    y1: -20,
    x2: 36,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 37,
    y1: -20,
    x2: 37,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38,
    y1: -20,
    x2: 38,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39,
    y1: -20,
    x2: 39,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: -20,
    x2: 40,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: -20,
    x2: 41,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42,
    y1: -20,
    x2: 42,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43,
    y1: -20,
    x2: 43,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 44,
    y1: -20,
    x2: 44,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: -20,
    x2: 45,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: -20,
    x2: 46,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47,
    y1: -20,
    x2: 47,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: -20,
    x2: 48,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49,
    y1: -20,
    x2: 49,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 50,
    y1: -20,
    x2: 50,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: -20,
    x2: 51,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: -20,
    x2: 52,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: -20,
    x2: 53,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 54,
    y1: -20,
    x2: 54,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 55,
    y1: -20,
    x2: 55,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: -20,
    x2: 56,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 57,
    y1: -20,
    x2: 57,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: -20,
    x2: 58,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: -20,
    x2: 59,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: -20,
    x2: 60,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61,
    y1: -20,
    x2: 61,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 62,
    y1: -20,
    x2: 62,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 63,
    y1: -20,
    x2: 63,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64,
    y1: -20,
    x2: 64,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 65,
    y1: -20,
    x2: 65,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: -20,
    x2: 66,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: -20,
    x2: 67,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 68,
    y1: -20,
    x2: 68,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69,
    y1: -20,
    x2: 69,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 70,
    y1: -20,
    x2: 70,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71,
    y1: -20,
    x2: 71,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72,
    y1: -20,
    x2: 72,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: -20,
    x2: 73,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74,
    y1: -20,
    x2: 74,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 75,
    y1: -20,
    x2: 75,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 76,
    y1: -20,
    x2: 76,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 77,
    y1: -20,
    x2: 77,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 78,
    y1: -20,
    x2: 78,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79,
    y1: -20,
    x2: 79,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 80,
    y1: -20,
    x2: 80,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81,
    y1: -20,
    x2: 81,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 82,
    y1: -20,
    x2: 82,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 83,
    y1: -20,
    x2: 83,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84,
    y1: -20,
    x2: 84,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 85,
    y1: -20,
    x2: 85,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: -20,
    x2: 86,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 87,
    y1: -20,
    x2: 87,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88,
    y1: -20,
    x2: 88,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 89,
    y1: -20,
    x2: 89,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 90,
    y1: -20,
    x2: 90,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 91,
    y1: -20,
    x2: 91,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 92,
    y1: -20,
    x2: 92,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 93,
    y1: -20,
    x2: 93,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 94,
    y1: -20,
    x2: 94,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: -20,
    x2: 95,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: -20,
    x2: 96,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 97,
    y1: -20,
    x2: 97,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98,
    y1: -20,
    x2: 98,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 99,
    y1: -20,
    x2: 99,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: -20,
    x2: 100,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: -20,
    x2: 101,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 102,
    y1: -20,
    x2: 102,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 103,
    y1: -20,
    x2: 103,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: -20,
    x2: 104,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 105,
    y1: -20,
    x2: 105,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: -20,
    x2: 106,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107,
    y1: -20,
    x2: 107,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108,
    y1: -20,
    x2: 108,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 109,
    y1: -20,
    x2: 109,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110,
    y1: -20,
    x2: 110,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 111,
    y1: -20,
    x2: 111,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 112,
    y1: -20,
    x2: 112,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 113,
    y1: -20,
    x2: 113,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: -20,
    x2: 114,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: -20,
    x2: 115,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116,
    y1: -20,
    x2: 116,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 117,
    y1: -20,
    x2: 117,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 118,
    y1: -20,
    x2: 118,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 119,
    y1: -20,
    x2: 119,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120,
    y1: -20,
    x2: 120,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 121,
    y1: -20,
    x2: 121,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 122,
    y1: -20,
    x2: 122,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123,
    y1: -20,
    x2: 123,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: -20,
    x2: 124,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 125,
    y1: -20,
    x2: 125,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 126,
    y1: -20,
    x2: 126,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 127,
    y1: -20,
    x2: 127,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128,
    y1: -20,
    x2: 128,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: -20,
    x2: 129,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: -20,
    x2: 130,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 131,
    y1: -20,
    x2: 131,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 132,
    y1: -20,
    x2: 132,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 133,
    y1: -20,
    x2: 133,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 134,
    y1: -20,
    x2: 134,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 135,
    y1: -20,
    x2: 135,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 136,
    y1: -20,
    x2: 136,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137,
    y1: -20,
    x2: 137,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 138,
    y1: -20,
    x2: 138,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139,
    y1: -20,
    x2: 139,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 140,
    y1: -20,
    x2: 140,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 141,
    y1: -20,
    x2: 141,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: -20,
    x2: 142,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 143,
    y1: -20,
    x2: 143,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144,
    y1: -20,
    x2: 144,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145,
    y1: -20,
    x2: 145,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 146,
    y1: -20,
    x2: 146,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 147,
    y1: -20,
    x2: 147,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: -20,
    x2: 148,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 149,
    y1: -20,
    x2: 149,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 150,
    y1: -20,
    x2: 150,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151,
    y1: -20,
    x2: 151,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: -20,
    x2: 152,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 153,
    y1: -20,
    x2: 153,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: -20,
    x2: 154,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 155,
    y1: -20,
    x2: 155,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 156,
    y1: -20,
    x2: 156,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 157,
    y1: -20,
    x2: 157,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: -20,
    x2: 158,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 159,
    y1: -20,
    x2: 159,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160,
    y1: -20,
    x2: 160,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 161,
    y1: -20,
    x2: 161,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 162,
    y1: -20,
    x2: 162,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 163,
    y1: -20,
    x2: 163,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 164,
    y1: -20,
    x2: 164,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 165,
    y1: -20,
    x2: 165,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166,
    y1: -20,
    x2: 166,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167,
    y1: -20,
    x2: 167,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168,
    y1: -20,
    x2: 168,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169,
    y1: -20,
    x2: 169,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 170,
    y1: -20,
    x2: 170,
    y2: 20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: 171,
    y1: -20,
    x2: 171,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172,
    y1: -20,
    x2: 172,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -20,
    x2: 173,
    y2: -20,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -19,
    x2: 173,
    y2: -19
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -18,
    x2: 173,
    y2: -18
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -17,
    x2: 173,
    y2: -17
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -16,
    x2: 173,
    y2: -16
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -15,
    x2: 173,
    y2: -15
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -14,
    x2: 173,
    y2: -14
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -13,
    x2: 173,
    y2: -13
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -12,
    x2: 173,
    y2: -12
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -11,
    x2: 173,
    y2: -11
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -10,
    x2: 173,
    y2: -10,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -9,
    x2: 173,
    y2: -9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -8,
    x2: 173,
    y2: -8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -7,
    x2: 173,
    y2: -7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -6,
    x2: 173,
    y2: -6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -5,
    x2: 173,
    y2: -5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -4,
    x2: 173,
    y2: -4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -3,
    x2: 173,
    y2: -3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -2,
    x2: 173,
    y2: -2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: -1,
    x2: 173,
    y2: -1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 0,
    x2: 173,
    y2: 0,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 1,
    x2: 173,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 2,
    x2: 173,
    y2: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 3,
    x2: 173,
    y2: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 4,
    x2: 173,
    y2: 4
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 5,
    x2: 173,
    y2: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 6,
    x2: 173,
    y2: 6
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 7,
    x2: 173,
    y2: 7
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 8,
    x2: 173,
    y2: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 9,
    x2: 173,
    y2: 9
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 10,
    x2: 173,
    y2: 10,
    strokeWidth: 0.075
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 11,
    x2: 173,
    y2: 11
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 12,
    x2: 173,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 13,
    x2: 173,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 14,
    x2: 173,
    y2: 14
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 15,
    x2: 173,
    y2: 15
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 16,
    x2: 173,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 17,
    x2: 173,
    y2: 17
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 18,
    x2: 173,
    y2: 18
  }), /*#__PURE__*/React.createElement("line", {
    x1: -5,
    y1: 19,
    x2: 173,
    y2: 19
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 1,
    fill: "black",
    stroke: "none",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 20,
    dy: -0.5
  }, "0cm"), /*#__PURE__*/React.createElement("text", {
    x: 10,
    y: 20,
    dy: -0.5
  }, "10"), /*#__PURE__*/React.createElement("text", {
    x: 20,
    y: 20,
    dy: -0.5
  }, "20"), /*#__PURE__*/React.createElement("text", {
    x: 30,
    y: 20,
    dy: -0.5
  }, "30"), /*#__PURE__*/React.createElement("text", {
    x: 40,
    y: 20,
    dy: -0.5
  }, "40"), /*#__PURE__*/React.createElement("text", {
    x: 50,
    y: 20,
    dy: -0.5
  }, "50"), /*#__PURE__*/React.createElement("text", {
    x: 60,
    y: 20,
    dy: -0.5
  }, "60"), /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 20,
    dy: -0.5
  }, "70"), /*#__PURE__*/React.createElement("text", {
    x: 80,
    y: 20,
    dy: -0.5
  }, "80"), /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 20,
    dy: -0.5
  }, "90"), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 20,
    dy: -0.5
  }, "100"), /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 20,
    dy: -0.5
  }, "110"), /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 20,
    dy: -0.5
  }, "120"), /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 20,
    dy: -0.5
  }, "130"), /*#__PURE__*/React.createElement("text", {
    x: 140,
    y: 20,
    dy: -0.5
  }, "140"), /*#__PURE__*/React.createElement("text", {
    x: 150,
    y: 20,
    dy: -0.5
  }, "150"), /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 20,
    dy: -0.5
  }, "160"), /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 20,
    dy: -0.5
  }, "170"), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 20,
    dx: 1.5
  }, "-20"), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 10,
    dx: 1.5
  }, "-10"), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: 0,
    dx: 1.5
  }, "0cm"), /*#__PURE__*/React.createElement("text", {
    x: -5,
    y: -10,
    dx: 1.5
  }, "10"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 1.5,
    fill: "black",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("text", {
    x: -4,
    y: 15
  }, "Nose"), /*#__PURE__*/React.createElement("text", {
    x: 172,
    y: 15,
    textAnchor: "end"
  }, "Tail"))), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    stroke: "black",
    strokeWidth: 0.1,
    fill: "none",
    points: " 0,-0 0.0054,0.435 0.0218,0.8697 0.0495,1.3037 0.0887,1.7367 0.1395,2.1683 0.2021,2.5981 0.2769,3.0259 0.364,3.4512 0.4636,3.8737 0.576,4.2931 0.7013,4.709 0.8398,5.1211 0.9916,5.529 1.1571,5.9324 1.3364,6.3309 1.5298,6.7242 1.7374,7.1119 1.9595,7.4937 2.1963,7.8692 2.448,8.2381 2.7147,8.6001 2.9969,8.9548 3.2946,9.3017 3.608,9.6407 3.9375,9.9714 4.2831,10.2933 4.6451,10.6062 5.0238,10.9097 5.4194,11.2034 5.8319,11.487 6.2618,11.7602 6.7092,12.0226 7.1743,12.2739 7.6573,12.5137 8.1585,12.7416 8.678,12.9574 9.2161,13.1606 9.7729,13.351 10.3488,13.5281 10.944,13.6916 11.5585,13.8412 12.1927,13.9766 12.8468,14.0973 13.521,14.2031 14.2155,14.2935 14.9304,14.3683 15.6662,14.4271 16.4229,14.4695 17.2007,14.4952 18,14.5039 18,14.5039 19.3581,14.4186 20.7164,14.335 22.0748,14.253 23.4333,14.1728 24.7919,14.0942 26.1506,14.0173 27.5094,13.9421 28.8683,13.8686 30.2273,13.7968 31.5863,13.7266 32.9455,13.6581 34.3047,13.5913 35.664,13.5262 37.0234,13.4628 38.3829,13.4011 39.7424,13.341 41.102,13.2826 42.4617,13.2259 43.8215,13.1709 45.1813,13.1175 46.5412,13.0659 47.9012,13.0159 49.2612,12.9676 50.6212,12.921 51.9814,12.8761 53.3415,12.8328 54.7018,12.7913 56.0621,12.7514 57.4224,12.7132 58.7828,12.6767 60.1432,12.6419 61.5037,12.6087 62.8642,12.5773 64.2247,12.5475 65.5853,12.5194 66.9459,12.493 68.3065,12.4682 69.6672,12.4452 71.0279,12.4238 72.3886,12.4041 73.7494,12.3862 75.1102,12.3698 76.471,12.3552 77.8318,12.3423 79.1926,12.331 80.5534,12.3214 81.9143,12.3135 83.2751,12.3073 84.636,12.3028 85.9969,12.3 87.3577,12.2988 88.7186,12.2993 90.0795,12.3015 91.4403,12.3054 92.8012,12.311 94.162,12.3183 95.5229,12.3272 96.8837,12.3378 98.2445,12.3501 99.6053,12.3641 100.966,12.3798 102.327,12.3972 103.688,12.4162 105.048,12.4369 106.409,12.4593 107.77,12.4834 109.13,12.5092 110.491,12.5367 111.851,12.5658 113.212,12.5966 114.572,12.6292 115.933,12.6634 117.293,12.6992 118.654,12.7368 120.014,12.776 121.374,12.817 122.734,12.8596 124.094,12.9039 125.455,12.9498 126.815,12.9975 128.175,13.0468 129.535,13.0978 130.894,13.1506 132.254,13.2049 133.614,13.261 134.974,13.3188 136.333,13.3782 137.693,13.4393 139.052,13.5021 140.411,13.5666 141.771,13.6327 143.13,13.7006 144.489,13.7701 145.848,13.8413 147.207,13.9142 148.566,13.9888 149.924,14.065 151.283,14.1429 152.642,14.2226 154,14.3039 154,14.3039 154.622,14.2953 155.227,14.27 155.815,14.2282 156.387,14.1702 156.944,14.0964 157.484,14.0072 158.008,13.9029 158.517,13.7839 159.01,13.6504 159.488,13.5028 159.951,13.3415 160.399,13.1669 160.832,12.9791 161.25,12.7787 161.654,12.5659 162.044,12.3411 162.42,12.1046 162.782,11.8568 163.13,11.5981 163.464,11.3286 163.785,11.0489 164.093,10.7592 164.387,10.4599 164.669,10.1514 164.938,9.8339 165.194,9.5078 165.438,9.1735 165.669,8.8313 165.888,8.4815 166.096,8.1245 166.292,7.7607 166.476,7.3904 166.649,7.0138 166.81,6.6314 166.96,6.2436 167.1,5.8506 167.229,5.4527 167.347,5.0505 167.454,4.6441 167.552,4.2339 167.639,3.8203 167.717,3.4036 167.785,2.9841 167.843,2.5623 167.892,2.1384 167.931,1.7127 167.961,1.2857 167.983,0.8577 167.996,0.429 168,-0 168,-0 167.996,-0.429 167.983,-0.8577 167.961,-1.2857 167.931,-1.7127 167.892,-2.1384 167.843,-2.5623 167.785,-2.9841 167.717,-3.4036 167.639,-3.8203 167.552,-4.2339 167.454,-4.6441 167.347,-5.0505 167.229,-5.4527 167.1,-5.8506 166.96,-6.2436 166.81,-6.6314 166.649,-7.0138 166.476,-7.3904 166.292,-7.7607 166.096,-8.1245 165.888,-8.4815 165.669,-8.8313 165.438,-9.1735 165.194,-9.5078 164.938,-9.8339 164.669,-10.1514 164.387,-10.4599 164.093,-10.7592 163.785,-11.0489 163.464,-11.3286 163.13,-11.5981 162.782,-11.8568 162.42,-12.1046 162.044,-12.3411 161.654,-12.5659 161.25,-12.7787 160.832,-12.9791 160.399,-13.1669 159.951,-13.3415 159.488,-13.5028 159.01,-13.6504 158.517,-13.7839 158.008,-13.9029 157.484,-14.0072 156.944,-14.0964 156.387,-14.1702 155.815,-14.2282 155.227,-14.27 154.622,-14.2953 154,-14.3039 154,-14.3039 152.642,-14.2226 151.283,-14.1429 149.924,-14.065 148.566,-13.9888 147.207,-13.9142 145.848,-13.8413 144.489,-13.7701 143.13,-13.7006 141.771,-13.6327 140.411,-13.5666 139.052,-13.5021 137.693,-13.4393 136.333,-13.3782 134.974,-13.3188 133.614,-13.261 132.254,-13.2049 130.894,-13.1506 129.535,-13.0978 128.175,-13.0468 126.815,-12.9975 125.455,-12.9498 124.094,-12.9039 122.734,-12.8596 121.374,-12.817 120.014,-12.776 118.654,-12.7368 117.293,-12.6992 115.933,-12.6634 114.572,-12.6292 113.212,-12.5966 111.851,-12.5658 110.491,-12.5367 109.13,-12.5092 107.77,-12.4834 106.409,-12.4593 105.048,-12.4369 103.688,-12.4162 102.327,-12.3972 100.966,-12.3798 99.6053,-12.3641 98.2445,-12.3501 96.8837,-12.3378 95.5229,-12.3272 94.162,-12.3183 92.8012,-12.311 91.4403,-12.3054 90.0795,-12.3015 88.7186,-12.2993 87.3577,-12.2988 85.9969,-12.3 84.636,-12.3028 83.2751,-12.3073 81.9143,-12.3135 80.5534,-12.3214 79.1926,-12.331 77.8318,-12.3423 76.471,-12.3552 75.1102,-12.3698 73.7494,-12.3862 72.3886,-12.4041 71.0279,-12.4238 69.6672,-12.4452 68.3065,-12.4682 66.9459,-12.493 65.5853,-12.5194 64.2247,-12.5475 62.8642,-12.5773 61.5037,-12.6087 60.1432,-12.6419 58.7828,-12.6767 57.4224,-12.7132 56.0621,-12.7514 54.7018,-12.7913 53.3415,-12.8328 51.9814,-12.8761 50.6212,-12.921 49.2612,-12.9676 47.9012,-13.0159 46.5412,-13.0659 45.1813,-13.1175 43.8215,-13.1709 42.4617,-13.2259 41.102,-13.2826 39.7424,-13.341 38.3829,-13.4011 37.0234,-13.4628 35.664,-13.5262 34.3047,-13.5913 32.9455,-13.6581 31.5863,-13.7266 30.2273,-13.7968 28.8683,-13.8686 27.5094,-13.9421 26.1506,-14.0173 24.7919,-14.0942 23.4333,-14.1728 22.0748,-14.253 20.7164,-14.335 19.3581,-14.4186 18,-14.5039 18,-14.5039 17.2007,-14.4952 16.4229,-14.4695 15.6662,-14.4271 14.9304,-14.3683 14.2155,-14.2935 13.521,-14.2031 12.8468,-14.0973 12.1927,-13.9766 11.5585,-13.8412 10.944,-13.6916 10.3488,-13.5281 9.7729,-13.351 9.2161,-13.1606 8.678,-12.9574 8.1585,-12.7416 7.6573,-12.5137 7.1743,-12.2739 6.7092,-12.0226 6.2618,-11.7602 5.8319,-11.487 5.4194,-11.2034 5.0238,-10.9097 4.6451,-10.6062 4.2831,-10.2933 3.9375,-9.9714 3.608,-9.6407 3.2946,-9.3017 2.9969,-8.9548 2.7147,-8.6001 2.448,-8.2381 2.1963,-7.8692 1.9595,-7.4937 1.7374,-7.1119 1.5298,-6.7242 1.3364,-6.3309 1.1571,-5.9324 0.9916,-5.529 0.8398,-5.1211 0.7013,-4.709 0.576,-4.2931 0.4636,-3.8737 0.364,-3.4512 0.2769,-3.0259 0.2021,-2.5981 0.1395,-2.1683 0.0887,-1.7367 0.0495,-1.3037 0.0218,-0.8697 0.0054,-0.435 0,-0 "
  })), /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "1,0.25",
    strokeOpacity: 0.5,
    onmouseover: "this.style['stroke-opacity']=1.0;",
    onmouseout: "this.style['stroke-opacity']=0.5;",
    stroke: "blue",
    strokeWidth: 0.1,
    fill: "none",
    style: {
      strokeOpacity: 0.5
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.000000 -13.503900 L18.000000 13.503900 M86.000000 -11.300000 L86.000000 11.300000 M84.000000 -7.300000 L84.000000 7.300000 M154.000000 -13.303900 L154.000000 13.303900"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "blue",
    strokeWidth: 0.1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 68,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 72,
    cy: 0,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 0,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 0,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 0,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104,
    cy: 0,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 108,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: -2,
    r: 0.9525,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: -2,
    r: 0.4737,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: -2,
    r: 0.05,
    fill: "blue",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    strokeDasharray: "1,0.25",
    strokeOpacity: 0.5,
    onmouseover: "this.style['stroke-opacity']=1.0;",
    onmouseout: "this.style['stroke-opacity']=0.5;",
    stroke: "green",
    strokeWidth: 0.1,
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 0,
    r: 0.25,
    fill: "green",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 0,
    r: 0.05,
    fill: "green",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 0,
    r: 0.25,
    fill: "green",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114,
    cy: 0,
    r: 0.05,
    fill: "green",
    fillOpacity: 0.25,
    strokeWidth: 0.01
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.000000 -4.000000 L88.000000 4.000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExampleOverview);
export default __webpack_public_path__ + "static/media/Example_Overview.aec8b882d46c177fcb82c4e84be048e2.svg";
export { ForwardRef as ReactComponent };